/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18.7427 5.933V4.5H21c.8284 0 1.5.6716 1.5 1.5v15c0 .8284-.6716 1.5-1.5 1.5H3c-.8284 0-1.5-.6716-1.5-1.5V6c0-.8284.6716-1.5 1.5-1.5h2.2427V6l.012.1348a.75.75 0 0 0 1.488-.1334V4.5h10.5v1.4985m0 0 .0121.1363Zm1.5.0015v-.067Zm0 0c-.0008.4135-.3363.75-.75.75a.7502.7502 0 0 1-.7379-.6152M6.7427 3h10.5V.75c.0008-.4135.3362-.75.75-.75a.7502.7502 0 0 1 .7379.6152l.0121.1348m0 0V3H21c1.6569 0 3 1.3431 3 3v15c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3V6c0-1.6569 1.3432-3 3-3h2.2427V.75c.0008-.4135.3362-.75.75-.75a.7502.7502 0 0 1 .7379.6152l.012.1348V3M6 10.5h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5Zm-.75 6.75A.75.75 0 0 1 6 16.5h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z"
    clipRule="evenodd"
  />,
  'Calendar'
);
